<template>
  <header class="app-modal-header">
    <slot />
  </header>
</template>

<script>
export default {
  name: 'AppModalHeader',
}
</script>

<style lang="scss" scoped>
@import '@/styles/settings.scss';

.app-modal-header {
  padding: $defaultPadding;

  > * {
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
